import { useTranslation } from "react-i18next";
import Spinner from "../../Fundamentals/Spinner/Spinner";

export default function CompensationList({ compensations, onClick, isLoading }) {
    const { t } = useTranslation();

    return (
        <table className="table table-stripe table-hover">
            <thead>
                <tr>
                    <th>{t('common.customernumber')}</th>
                    <th>{t('common.product')}</th>
                    <th>{t('compensationtable.compensationreason')}</th>
                </tr>
            </thead>
            <tbody>
                {isLoading ? (
                    <tr>
                        <td colSpan="3" className="text-center">
                            <Spinner />
                        </td>
                    </tr>
                ) : compensations && compensations.length > 0 ? (
                    compensations.map((compensation, index) => (
                        <tr key={index} onClick={() => onClick(compensation)}>
                            <td>{compensation.customerNumber}</td>
                            <td>{compensation.productName}</td>
                            <td>{compensation.reasonName}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="3">
                            <em>{t('compensationtable.nocompensationsfound')}</em>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}